import React from 'react';
import { useNavigation } from '../contexts/NavigationContext';
import { DashboardMode } from './modes/DashboardMode';
import { TodosMode } from './modes/TodosMode';
import { NotesMode } from './modes/NotesMode';
import { CalendarMode } from './modes/CalendarMode';
import { KanbanMode } from './modes/KanbanMode';

export const ModeRenderer: React.FC = () => {
  const { currentMode } = useNavigation();

  switch (currentMode) {
    case 'dashboard':
      return <DashboardMode />;
    case 'notes':
      return <NotesMode />;
    case 'calendar':
      return <CalendarMode />;
    case 'kanban':
      return <KanbanMode />;
    case 'todos':
      return <TodosMode />;
    default:
      return <DashboardMode />;
  }
};
